import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./TableContainer.module.scss";

const TableContainer = forwardRef(({ className, component: Component, ...rest }, ref) => {
  return <Component ref={ref} className={cn(styles.container, className)} {...rest} />;
});

TableContainer.displayName = "TableContainer";

TableContainer.defaultProps = {
  component: "div",
  className: undefined
};

TableContainer.propTypes = {
  /**
   * The table itself, normally `<Table />`
   */
  children: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType
};

export default TableContainer;
